import { UnknownAction } from "redux";
import axios from "../../../config/axiosInterceptor";
import { AxiosResponse } from "axios";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { useNavigate } from "react-router-dom";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const isLoggedIn = () => {
  return !!localStorage.getItem("@lsToken");
};

export const loading = (data: boolean): UnknownAction => {
  return {
    type: action_types.SET_LOADING,
    payload: { loading: data },
  };
};

export const resetPassword = ({
  newPassword,
  token,
}: {
  newPassword: string;
  token: string;
}): Promise<AxiosResponse<{ message: string; success: boolean }>> => {
  const data = {
    newPassword,
  };
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post(`${baseURL}resetPassword`, data, config);
};

export const loginToken = (data: {
  accessToken: string;
  refreshToken: string;
}): UnknownAction => {
  return {
    type: action_types.LOGIN,
    data,
  };
};

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("@landScalingToken"); // Or localStorage.clear()
    navigate("/login");
  };

  return logout; // Return the logout function
};
